import { Alert, Box, Button } from '@mui/material';
import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { exportCompanyConsumptionSummary } from '../../../../../actions/carbonfootprint-rework/06-dashboard/01-dashboard';
import { triggerExcelDownload } from '../utils/export-utils';

/**
 * Wraps export button in the Company Overview Emissions section
 * @param {Object} props 
 * @param {number} props.companyId Selected Company ID
 * @param {string} props.year The literal year value
 * @param {string} props.companyName Company Name to reference in exported document
 * @returns {JSX.Element}
 */
export default function ExportCompanyConsumptionOverview({ companyId, year, companyName }) {
    const [isExportingDocument, setIsExportingDocument] = useState(false)
    const [formError, setFormError] = useState(null)
    const dispatch = useDispatch()
    const downloadTitle = `${companyName} Consumption Summary for ${year}.xlsx`

    async function handleExportDocument() {
        try {
            setIsExportingDocument(true)
            await triggerExcelDownload(dispatch, exportCompanyConsumptionSummary, [companyId, year], downloadTitle)
            handleFormReset()
        } catch (error) {
            setFormError('Something went wrong.')
        }
        finally { setIsExportingDocument(false) }
    }

    const handleFormReset = () => {
        setFormError(null)
    }

    return (
        <Box sx={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', gap: 3 }}>
            {
                formError &&
                <Alert
                    severity='error'
                    sx={{ width: 'fit-content' }}
                >
                    {formError}
                </Alert>
            }
            <Button
                variant='outlined'
                sx={{ width: 'fit-content' }}
                disabled={isExportingDocument}
                onClick={handleExportDocument}>
                {isExportingDocument ? 'Exporting...' : 'Export Excel Summary'}
            </Button>
        </Box>
    )
}
